import Tools from '../tools/tools.js'
/* 校验当前是否为go车 */
export function isGoEnv () {
  const pvAreaId = Tools.getQueryString('pvareaId');
  if (pvAreaId === '6853648') {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/service/vaildGo.service.js